import React, { Component } from 'react';

class AboutMe extends Component {
    render() {
        
        return (
            <div className="AboutMe">
               
               <h2>top 👋🏽 things to know about me</h2>
               👆🏽 My strong interpersonal and analytic skills come from a 10 year background in child education and an MA in School Psychology<p></p>
               ✌🏽 I made my transition to software engineering in November 2021, and have since graduated from Fullstack Academy, coded several group and solo web applications,  <p></p>
               🤟🏽 The things I loved the most about youth education &mdash; collaboration, initiative, resourcefulness &mdash; are the very same features that draw me to software engineering<p></p>
  
               👍🏽 What really excites me is education technology, and I love to explore creative hardware and software <p></p>
               🤚🏽 When not coding, I&rsquo;m ususally drawing, reading, cooking, or playing strategy games
            </div>
            )}
}
export default AboutMe